// frontend/src/services/annotationService.js
// Whole-lesson human annotation (YES-227, YES-206; call map section 12): the coding sheet, its
// codebook, one draft pick at a time, and submit. The sheet is speakers and text and the caller's own
// drafts only: never another label layer, model or LLM output, flags or the lesson's identity.
// Replaces the legacy /api/annotations/* task routes; their screens were retired with YES-253.
import api from './api';

const enc = encodeURIComponent;

// { assignmentId, label, savedAt, coded, total, lines: [{ seq, speakerRole, text, ut?, rc? }] }; 409 once submitted
export const getSheet = async (assignmentId) => (await api.get(`/api/annotations/${enc(assignmentId)}`)).data;

export const getAnnotationCodebook = async (assignmentId) => {
    const { data } = await api.get(`/api/annotations/${enc(assignmentId)}/codebook`);
    return { version: data.version, ut: data.ut, rc: data.rc };
};

// One pick, saved as soon as it is made; a dimension left out is kept. → { savedAt, coded, total }
export const saveCode = async (assignmentId, seq, codes) =>
    (await api.put(`/api/annotations/${enc(assignmentId)}/codes/${enc(seq)}`, codes)).data;

// Final: appends the annotator label layer once; 409 while utterances are left to code
export const submitLesson = async (assignmentId) => (await api.post(`/api/annotations/${enc(assignmentId)}/submit`)).data;
